import { AddInvoiceRequestItem, AddInvoiceRequestItemArray } from '../ss-api/requests/add.invoice.request';

export interface IInvoiceItem {

    ID: number;
    LicenseID: number;
    CDKey: string;
    Description: string;
    Amount: number;    
    TaxRate: number;
    TaxCode: string;
    TaxedAmount: number;
    CustomTaxRatDisplay: string;
}

export class InvoiceItem implements IInvoiceItem {

    ID: number;
    LicenseID: number;
    CDKey: string;
    Description: string;
    Amount: number;
    TaxRate: number;
    TaxCode: string;
    TaxedAmount: number;
    CustomTaxRatDisplay: string;

    public static convertToInvoiceRequestItem( Item: InvoiceItem ): AddInvoiceRequestItem {
        let newItem = new AddInvoiceRequestItem();
        newItem.Amount = Item.Amount;
        newItem.Description = Item.Description;
        newItem.ID = Item.ID;
        return newItem;
    }

}

export class InvoiceItemArray extends Array<InvoiceItem>  {

    constructor(...items: InvoiceItem[]) {
        super(...items);
        Object.setPrototypeOf(this, InvoiceItemArray.prototype);
    }

    public static convertToInvoiceRequestItems( Items: InvoiceItemArray ): AddInvoiceRequestItemArray {
        let newItems = new AddInvoiceRequestItemArray();
        Items.forEach(e => {
            newItems.push( InvoiceItem.convertToInvoiceRequestItem(e) );
        });
        return newItems;
    }

}
